import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { ClerkProviderWithRouter } from '@/components/ClerkProviderWithRouter'
import { QueryProvider } from '@/data/QueryProvider'
import { AppErrorBoundary } from '@/components/AppErrorBoundary'
import App from './App'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppErrorBoundary>
        <BrowserRouter>
          <ClerkProviderWithRouter>
            <QueryProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </QueryProvider>
          </ClerkProviderWithRouter>
        </BrowserRouter>
      </AppErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
)
